import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { storageSet, storageGet, storageRemove } from "../../../Libs/Collector/StorageAction";
import { Crypto } from "../../../Libs/Security/Crypto";
import api from "../../../Libs/Api/AxiosConfig";

export const adminLogin = createAsyncThunk(
    'AdminAuth/login',
    async (data) => {
        // Normal login gibi: username + password RSA+AES içine sarılı JWT olarak gönderilir
        const res = await api.post('/Admin/Login', {
            username: await Crypto(data.username),
            password: await Crypto(data.password),
        });
        return res.data;
    }
);

export const adminFetchLayout = createAsyncThunk(
    'AdminAuth/layout',
    async () => {
        const res = await api.post('/Admin/Layout');
        return res.data;
    }
);

export const adminLogout = createAsyncThunk(
    'AdminAuth/logout',
    async () => {
        try { await api.post('/Admin/Logout'); } catch (e) { /* yine de localStorage temizlenir */ }
        return true;
    }
);

const hasToken = !!storageGet('adminToken');

export const AdminAuthSlice = createSlice({
    name: 'AdminAuth',
    initialState: {
        loading: false,
        loadingLayout: false,
        error: false,
        reason: '',
        auth: hasToken,
        user: null,
        modules: [],
    },
    reducers: {
        ClearAdminError: (state) => {
            state.error = false;
            state.reason = '';
        },
        AdminLogoutReducer: (state) => {
            storageRemove('adminToken');
            storageRemove('adminRefreshToken');
            state.auth = false;
            state.user = null;
            state.modules = [];
            state.reason = '';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(adminLogin.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.reason = '';
        });
        builder.addCase(adminLogin.fulfilled, (state, { payload }) => {
            state.loading = false;
            const p = payload?.payload;
            if (p?.status && p.token) {
                storageSet('adminToken', p.token);
                storageSet('adminRefreshToken', p.refreshToken);
                state.auth = true;
                state.user = p.user || null;
                state.error = false;
                state.reason = '';
            } else {
                state.auth = false;
                state.error = true;
                state.reason = p?.reason || 'login_failed';
            }
        });
        builder.addCase(adminLogin.rejected, (state) => {
            state.loading = false;
            state.error = true;
            state.reason = 'network_error';
        });

        builder.addCase(adminFetchLayout.pending, (state) => {
            state.loadingLayout = true;
        });
        builder.addCase(adminFetchLayout.fulfilled, (state, { payload }) => {
            state.loadingLayout = false;
            const p = payload?.payload;
            if (p?.status && p.data) {
                state.modules = p.data.modules || [];
                state.user = p.data.user || state.user;
                state.auth = true;
            }
        });
        builder.addCase(adminFetchLayout.rejected, (state) => {
            state.loadingLayout = false;
        });

        builder.addCase(adminLogout.fulfilled, (state) => {
            storageRemove('adminToken');
            storageRemove('adminRefreshToken');
            state.auth = false;
            state.user = null;
            state.modules = [];
        });
    },
});

export const { ClearAdminError, AdminLogoutReducer } = AdminAuthSlice.actions;
export const AdminAuthReducer = AdminAuthSlice.reducer;
